import { GA4_MEASUREMENT_ID, GOOGLE_ADS_ID } from '@m/config/env';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Sends a gtag.js event to every configured destination (GA4 and Google Ads).
 *
 * No-ops when the tag was never loaded — the snippet is only injected when a
 * measurement id is present, so this is silent outside production.
 */
export function gtagEvent(name: string, params?: Record<string, unknown>) {
  window.gtag?.('event', name, params);
}

/**
 * Sends a GA4 `page_view`. The base snippet sets `send_page_view: false`, so
 * every page view — including the first — comes from here.
 */
export function gtagPageView(params: {
  page_location?: string;
  page_path?: string;
  page_title?: string;
}) {
  if (!GA4_MEASUREMENT_ID) {
    return;
  }
  gtagEvent('page_view', { send_to: GA4_MEASUREMENT_ID, ...params });
}

/**
 * Builds the Google Ads `send_to` target from the account id and a bare
 * conversion label, e.g. `AW-16609902287/1FreCITcze4ZEM_9m_A9`.
 *
 * Returns undefined when either half is unset so callers skip the event rather
 * than sending a conversion to a malformed destination.
 */
export function getAdsSendTo(label?: string) {
  if (!GOOGLE_ADS_ID || !label) {
    return undefined;
  }
  return `${GOOGLE_ADS_ID}/${label}`;
}
